var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxIndeterminate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox-indeterminate"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    width: 27,
    height: 27,
    rx: 3,
    fill: "#23bb79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "dash",
    x: 6.6,
    y: 12.2,
    width: 13.8,
    height: 2.6,
    rx: 1.3,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIndeterminate);
export default __webpack_public_path__ + "static/media/checkbox-indeterminate.b0f83192684e6dec80981155fabbb2b1.svg";
export { ForwardRef as ReactComponent };